import styled from "@mui/styled-engine";
import {MaterialDesignContent} from "notistack";
import theme from "./theme";

const snackbarStyledContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
        backgroundColor: `${theme.palette.secondary.main}`,
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: `${theme.palette.error.main}`,
    },
    '&.notistack-MuiContent-info': {
        backgroundColor: `${theme.palette.info.main}`,
    },
    '&.notistack-MuiContent-warning': {
        backgroundColor: `${theme.palette.warning.main}`,
    },
}));

export default snackbarStyledContent